import { Component, computed, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilityService } from '@eforall/common';
import { DashboardDialogFramePart, DialogAction, DialogContext, DialogService } from '@eforall/dashboard';
import { LanguageId } from '@interfaces';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { EventDetailsPart } from './details/details.part';
import { EventDialogDataService } from './event-dialog-data.service';
import { EventDialogEditorPart } from './edit/event-editor.part';

@Component({
	selector: 'event-dialog',
	imports: [
		DashboardDialogFramePart,
		TabStripModule,
		EventDetailsPart,
		EventDialogEditorPart
	],
	templateUrl: './event.dialog.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./event.dialog.scss'],
})
export class EventDialog implements OnInit {
	public dialog: DialogContext<{ eventId: number }> = inject(MAT_DIALOG_DATA);
	public dialogRef = inject(MatDialogRef<EventDialog>);
	private eventDialogDataService = inject(EventDialogDataService);
	public util = inject(UtilityService);
	public dialogService = inject(DialogService);

	closeAction: DialogAction = {
		id: 'close',
		enabled: signal(true),
		cssClass: signal(undefined),
		visible: signal(true),
		text: signal('Close'),
		linkType: 'callback',
		callback: async () => this.close(),
		willCloseDialog: true,
	};
	actions = [this.closeAction];

	icon = signal('fa-regular fa-calendar');

	header = computed(() => {
		const event = this.eventDialogDataService.event();
		return event ? `${event.eventType.fullName} Event - ${event.languageId == LanguageId.Espanol ? 'ES' : 'EN'}` : 'No Event';
	});

	public timezone = this.util.date.getTimezone();


	public isReadonly = computed(() => !this.eventDialogDataService.canEdit());

	async ngOnInit() {
		const eventId = this.dialog.data?.eventId;
		if (eventId) {
			await this.eventDialogDataService.loadEventData(eventId);
		}
	}

	close() {
		this.dialogRef.close();
	}

}
